import Vue from 'vue';
import Vuex from 'vuex';

import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

import VuexPersistence from 'vuex-persist';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: (state) => ({
    token: state.token,
    refreshToken: state.refreshToken,
    userId: state.userId,
    user: state.user,
    username: state.username,
    sendedNewComer: state.sendedNewComer,
    sendedBornTodayUsers: state.sendedBornTodayUsers,
  }),
});

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  plugins: [vuexLocal.plugin],
});
